import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import moment from 'moment'

import {
  startCompanyCreationV2,
  getCompanyCreationV2StatutsDownloadUrl,
  uploadCompanyCreationV2CapitalDepositCertificate,
} from '@api/company-creation-v2'
import FileField from '@components/ui-v2/FileField'
import CustomerAreaTitle from '../Display/CustomerAreaTitle'
import Button from '../../ui/Button'
import fetchWrapper from 'Helpers/fetch-wrapper'
import { uploadErrorMessage } from '../../FormaliteFormsV2/CreationForm/Justifs/logic'

import './formalites-page.sass'

// date after which formalites can display suivi, because formalists start using forestadmin
const FORMALITE_CHANGE_DATE = moment('13/09/2023', 'DD/MM/YYYY')

// Tunnel v2 de création de société (hors micro) : reprend lui-même le dossier à son `step`, aucun
// paramètre d'URL nécessaire.
const CREATION_V2_URL = '/creation-entreprise/dossier'

class FormalitePage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      existingTransfert: null,
      transfertType: null,
      transfertLoaded: false,
      existingCreation: null,
      creationType: null,
      creationLoaded: false,
      startingCreation: false,
      startCreationError: false,
      downloadingStatuts: false,
      downloadStatutsError: false,
      capitalDepositCertificateFile: null,
      uploadingCapitalDepositCertificate: false,
      capitalDepositCertificateError: null,
      capitalDepositCertificateUploaded: false,
    }
  }

  componentDidMount() {
    fetchWrapper('/api/formalites/transfert-siege/current-user')
      .then(res => {
        this.setState({
          existingTransfert: res.transfert,
          transfertType: res.type,
          transfertLoaded: true,
        })
      })
    fetchWrapper('/api/company-creation/current-user')
      .then(res => {
        this.setState({
          existingCreation: res.companyCreation,
          creationType: res.type,
          creationLoaded: true,
        })
      })
  }

  startCreation = () => {
    const { history } = this.props
    this.setState({ startingCreation: true, startCreationError: false })
    startCompanyCreationV2()
      .then(() => history.push(CREATION_V2_URL))
      .catch(() => this.setState({ startingCreation: false, startCreationError: true }))
  }

  // URL S3 pré-signée demandée au clic (toujours valide) ; disposition `attachment` : le navigateur
  // télécharge sans quitter la page.
  downloadStatuts = () => {
    this.setState({ downloadingStatuts: true, downloadStatutsError: false })
    getCompanyCreationV2StatutsDownloadUrl()
      .then(response => {
        this.setState({ downloadingStatuts: false })
        window.location.assign(response.data.url)
      })
      .catch(() => this.setState({ downloadingStatuts: false, downloadStatutsError: true }))
  }

  // Attestation de dépôt de capital envoyée depuis l'espace client (décision de l'appel Jules /
  // Cédric du 2026-09-28) : le tunnel ne la demande plus, elle peut arriver jusqu'à 3 semaines
  // après un dépôt en banque. Même contrat d'erreur que l'écran Justificatifs.
  uploadCapitalDepositCertificate = () => {
    const { capitalDepositCertificateFile } = this.state
    if (!capitalDepositCertificateFile) return
    this.setState({
      uploadingCapitalDepositCertificate: true,
      capitalDepositCertificateError: null,
    })
    uploadCompanyCreationV2CapitalDepositCertificate(capitalDepositCertificateFile)
      .then(() => this.setState({
        uploadingCapitalDepositCertificate: false, capitalDepositCertificateUploaded: true,
      }))
      .catch((error) => this.setState({
        uploadingCapitalDepositCertificate: false,
        capitalDepositCertificateError: uploadErrorMessage(error),
      }))
  }

  renderTransfert() {
    const { existingTransfert, transfertLoaded } = this.state
    if (!transfertLoaded) return null
    
    if (!existingTransfert || !existingTransfert.finalized || moment(existingTransfert.created_at).isBefore(FORMALITE_CHANGE_DATE)) {
      return this.renderTransfertButton()
    }
    
    return this.renderTransfertStatus()
  }

  renderAssignee(assignee) {
    if (!assignee) return null

    let email = 'speedformalis@gmail.com' // Sandy
    switch (assignee) {
      case 'Robin':
        email = 'rcformalites@gmail.com'
        break
      case 'Marine':
        email = 'mgconseils.juridique@gmail.com'
        break
      case 'Emilie':
        email = 'emilie@ma-domiciliation.fr'
        break
      case 'Enzo':
        email = 'enzo@ma-domiciliation.fr'
        break
      case 'Jayson':
        email = 'jayson@ma-domiciliation.fr'
        break
      case 'Margaux':
        email = 'margaux@ma-domiciliation.fr'
        break
    }

    return (
      <div className="formalite-status-subtitle mt-6">
        Pour toute question vous pouvez contacter notre formaliste par email à cette adresse :<br/>{email}
      </div>
    )
  }
  
  renderTransfertStatus() {
    const { kbis_obtenu } = this.state.existingTransfert
    const isMicro = this.state.transfertType === 'microTransfert'
    let step = 1
    
    if (isMicro) {
      const { pouvoir, depot_inpi } = this.state.existingTransfert

      if (pouvoir && depot_inpi) step = 2
    } else {
      const { paiement_depot_greffe } = this.state.existingTransfert
      
      if (paiement_depot_greffe) step = 2
    }
    
    if (kbis_obtenu) step = 3

    return (
      <div className="formalite-status">
        <div className="formalite-status-title">Suivi de votre formalité</div>
        <div className="formalite-status-list">
          <div className={`formalite-status-item${step=== 1 ? ' active' : ''}`}>1. Signature de vos documents juridiques</div>
          {step === 1 && (
            <div className="formalite-status-subtitle">Votre formaliste va vous envoyer sous 72h une série de documents à signer via l'outil Yousign. Vérifiez régulièrement votre boite mail.</div>
          )}
          <div className={`formalite-status-item${step=== 2 ? ' active' : ''}`}>2. Dépôt de votre dossier auprès {isMicro ? 'de l’INPI' : 'du greffe'}</div>
          {step === 2 && (
            <div className="formalite-status-subtitle">Votre dossier a été déposé auprès {isMicro ? 'de l’INPI' : 'du greffe'}. Nous attendons que le greffe traite votre dossier. Attention : les délais sont très variables, et peuvent aller jusqu'à plusieurs semaines.</div>
          )}
          <div className={`formalite-status-item${step=== 3 ? ' active' : ''}`}>3. Votre nouveau kbis</div>
          {step === 3 && (
            <div className="formalite-status-subtitle">Votre nouveau Kbis vous a été envoyé par email !</div>
          )}
        </div>
        {this.renderAssignee(this.state.existingTransfert?.assignee)}
      </div>
    )
  }
  
  renderTransfertButton() {
    const { juridic_form, id, contracts } = this.props.currentUser
    const { existingTransfert } = this.state

    if (contracts[0]?.address?.status !== 1 && ![1,2].includes(contracts[0]?.address?.id)) {
      return 'Formalités non disponibles, merci de vous rapprocher du service client (contact@ma-domiciliation.fr)'
    }

    if (!['SAS', 'SASU', 'SARL', 'EURL', 'SCI', 'Micro-entreprise', 'EI'].includes(juridic_form)) {
      return `Cette formalité n'est pas disponible pour votre forme juridique (${juridic_form}).`
    }
    
    const urlPrefix = (juridic_form === 'Micro-entreprise' || juridic_form === 'EI') ? '/micro' : ''

    if (existingTransfert) {
      if (existingTransfert.finalized) {
        return 'Vous avez déjà terminé une demande de transfert de siège.'
      }
      
      let urlPart = 'transfert-de-siege'
      if (existingTransfert.invoice_id) urlPart = 'transfert-de-siege-dossier'
      // Étape actionnaires : société seulement (pas de transfer_date ni d'écran pour la micro)
      if (existingTransfert.transfer_date && urlPrefix === '') urlPart = 'transfert-de-siege-actionnaires'

      return (
        <Link to={`${urlPrefix}/${urlPart}?transfert_id=${existingTransfert.id}`}>
          <Button label="Finaliser ma formalité" secondaryClass="primary" />
        </Link>
      )
    }

    return (
      <Link to={`${urlPrefix}/transfert-de-siege?user_id=${id}`}>
        <Button label="Commencer" secondaryClass="primary" />
      </Link>
    )
  }
  
  renderCreation() {
    const { existingCreation, creationLoaded } = this.state
    if (!creationLoaded) return null
    
    if (!existingCreation || !existingCreation.finalized || moment(existingCreation.created_at).isBefore(FORMALITE_CHANGE_DATE)) {
      return this.renderCreationButton()
    }
    
    return this.renderCreationStatus()
  }

  renderCreationStatus() {
    const { kbis_obtenu } = this.state.existingCreation
    const isMicro = this.state.creationType === 'microCreation'
    let step = 1
    
    if (isMicro) {
      const { pouvoir, dnc, depot_inpi } = this.state.existingCreation

      if (pouvoir && dnc && depot_inpi) step = 2
    } else {
      const { envoi_greffe } = this.state.existingCreation
      
      if (envoi_greffe) step = 2
    }
    
    if (kbis_obtenu) step = 3

    return (
      <div className="formalite-status">
        <div className="formalite-status-title">Suivi de votre formalité</div>
        <div className="formalite-status-list">
          <div className={`formalite-status-item${step=== 1 ? ' active' : ''}`}>1. Signature de vos documents juridiques</div>
          {step === 1 && (
            <div className="formalite-status-subtitle">Votre formaliste va vous envoyer sous 72h une série de documents à signer via l'outil Yousign. Vérifiez régulièrement votre boite mail.</div>
          )}
          <div className={`formalite-status-item${step=== 2 ? ' active' : ''}`}>2. Dépôt de votre dossier auprès {isMicro ? 'de l’INPI' : 'du greffe'}</div>
          {step === 2 && (
            <div className="formalite-status-subtitle">Votre dossier a été déposé auprès {isMicro ? 'de l’INPI' : 'du greffe'}. Nous attendons que le greffe traite votre dossier. Attention : les délais sont très variables, et peuvent aller jusqu'à plusieurs semaines.</div>
          )}
          <div className={`formalite-status-item${step=== 3 ? ' active' : ''}`}>3. Votre nouveau kbis</div>
          {step === 3 && (
            <div className="formalite-status-subtitle">Votre nouveau Kbis vous a été envoyé par email !</div>
          )}
        </div>
        {!isMicro && this.renderCreationStatuts()}
        {!isMicro && this.renderCapitalDepositCertificate()}
        {this.renderAssignee(this.state.existingCreation?.assignee)}
      </div>
    )
  }

  // Statuts du dossier envoyé : version signée (Firma) en priorité, sinon le fichier courant —
  // projet rédigé depuis le questionnaire, ou statuts déposés par le client (que le formaliste peut
  // avoir corrigés puis re-déposés). Mêmes règles que `GET /api/company-creation-v2/statuts/
  // download-url`.
  renderCreationStatuts() {
    const { existingCreation, downloadingStatuts, downloadStatutsError } = this.state
    const { statuts_signed_file, statuts_file, statuts_provided_by_client } = existingCreation
    const isSigned = !!statuts_signed_file
    if (!isSigned && !statuts_file) return null

    const isGeneratedProject = !isSigned && !statuts_provided_by_client
    let label = 'Télécharger mes statuts'
    if (isSigned) label = 'Télécharger mes statuts signés'
    else if (isGeneratedProject) label = 'Télécharger mon projet de statuts'

    return (
      <div className="formalite-statuts mt-6">
        <div className="formalite-status-item active">Vos statuts</div>
        {isGeneratedProject && (
          <div className="formalite-status-subtitle">
            Projet de statuts rédigé à partir de votre dossier. Vous le signerez en ligne, avec vos
            éventuels associés, après validation par votre formaliste.
          </div>
        )}
        <Button
          label={label}
          secondaryClass="primary"
          disabled={downloadingStatuts}
          onClick={this.downloadStatuts}
        />
        {downloadStatutsError && (
          <div className="formalite-status-subtitle">
            Impossible de récupérer vos statuts, merci de réessayer.
          </div>
        )}
      </div>
    )
  }

  // Bloc « Attestation de dépôt de capital » (sociétés, dossier envoyé et pas encore déposé au
  // greffe — au-delà, l'attestation n'a plus d'utilité) : zone de dépôt PDF tant que l'attestation
  // manque — quel que soit le mode de dépôt, Qonto ne la renvoie automatiquement que pour une
  // inscription passée par l'API —, puis confirmation une fois reçue.
  renderCapitalDepositCertificate() {
    const {
      existingCreation, capitalDepositCertificateFile, uploadingCapitalDepositCertificate,
      capitalDepositCertificateError, capitalDepositCertificateUploaded,
    } = this.state
    if (existingCreation.envoi_greffe || existingCreation.kbis_obtenu) return null
    const isReceived = capitalDepositCertificateUploaded
      || !!existingCreation.capital_deposit_certificate_file

    return (
      <div className="formalite-capital-deposit mt-6 max-w-[560px]">
        <div className="formalite-status-item active">Attestation de dépôt de capital</div>
        {isReceived ? (
          <div className="formalite-status-subtitle">
            Attestation reçue : votre formaliste l&apos;ajoute à votre dossier pour le dépôt
            au greffe.
          </div>
        ) : (
          <>
            <div className="formalite-status-subtitle">
              Le greffe en a besoin pour immatriculer votre société. Transmettez-la-nous dès que
              votre banque ou Qonto vous l&apos;aura remise.
            </div>
            <FileField
              name="capital_deposit_certificate"
              label="Attestation de dépôt de capital"
              hint="Au format PDF, 20 Mo max"
              file={capitalDepositCertificateFile}
              onFileSelect={(file) => this.setState({
                capitalDepositCertificateFile: file,
                capitalDepositCertificateError: null,
              })}
              error={capitalDepositCertificateError}
            />
            <div className="mt-4">
              <Button
                label="Envoyer mon attestation"
                secondaryClass="primary"
                disabled={!capitalDepositCertificateFile || uploadingCapitalDepositCertificate}
                onClick={this.uploadCapitalDepositCertificate}
              />
            </div>
          </>
        )}
      </div>
    )
  }

  renderCreationButton() {
    const { juridic_form, id, has_pending_prepaid_company_creation, contracts } = this.props.currentUser
    const { existingCreation } = this.state

    if (contracts[0]?.address?.status !== 1 && ![1,2].includes(contracts[0]?.address?.id)) { // id 1 and 2 are allowed because even if they are disabled, they are old versions of active addresses
      return 'Formalités non disponibles, merci de vous rapprocher du service client (contact@ma-domiciliation.fr)'
    }

    if (!['SAS', 'SASU', 'SARL', 'EURL', 'SCI', 'Micro-entreprise', 'EI'].includes(juridic_form)) {
      return `Cette formalité n'est pas disponible pour votre forme juridique (${juridic_form}).`
    }
    
    const isMicro = juridic_form === 'Micro-entreprise' || juridic_form === 'EI'

    if (existingCreation) {
      if (existingCreation.finalized) {
        return 'Vous avez déjà terminé une demande de création de société.'
      }

      // Société : le tunnel v2 reprend le dossier à son propre `step` (un dossier de l'ancien tunnel
      // repart du premier écran, cf. specs/features/creation-societe-v2/parcours.md
      // § 5).
      if (!isMicro) {
        return (
          <Link to={CREATION_V2_URL}>
            <Button label="Finaliser ma formalité" secondaryClass="primary" />
          </Link>
        )
      }

      const linkUrl = existingCreation.invoice_id // check if already paid
        ? 'creation-entreprise-dossier'
        : 'creation-entreprise-informations'

      return (
        <Link to={`/micro/${linkUrl}?company_creation_id=${existingCreation.id}`}>
          <Button label="Finaliser ma formalité" secondaryClass="primary" />
        </Link>
      )
    }

    if (isMicro) {
      return (
        <Link to="/micro/creation-entreprise-informations">
          <Button label="Commencer" secondaryClass="primary" />
        </Link>
      )
    }

    // Société : le dossier doit exister avant d'ouvrir le tunnel v2 (`GET /session` le lit).
    const { startingCreation, startCreationError } = this.state
    return (
      <>
        <Button
          label="Commencer"
          secondaryClass="primary"
          disabled={startingCreation}
          onClick={this.startCreation}
        />
        {startCreationError && (
          <div className="formalite-status-subtitle">
            Impossible de démarrer votre dossier, merci de réessayer.
          </div>
        )}
      </>
    )
  }

  render() {
    return (
      <div className="FormalitePage customer-area-content-mobile-container">
        <CustomerAreaTitle label="Formalités Juridiques" icon="ic-mon-contrat" />
        <div className="formalite-description">
          L'équipe de ma-domiciliation.fr peut prendre en charge le transfert de votre siège, ou la création de votre société.
        </div>
        <div className="formalite-content mb-8">
          <span className="formalite-name">Transfert de siège&nbsp;:</span>
          {this.renderTransfert()}
        </div>
        <div className="formalite-content">
          <span className="formalite-name">Création de société&nbsp;:</span>
          {this.renderCreation()}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  currentUser: state.user.currentUser,
})

export default connect(mapStateToProps)(FormalitePage)
